import { render } from "./Layouts.vue?vue&type=template&id=c6c24a0a&scoped=true"
import script from "./Layouts.vue?vue&type=script&lang=js"
export * from "./Layouts.vue?vue&type=script&lang=js"

import "./Layouts.vue?vue&type=style&index=0&id=c6c24a0a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6c24a0a"]])

export default __exports__